import React, { Component ,Fragment} from 'react';
import Breadcrumb from "../../../common/breadcrumb"
import { getObject, updateObject, packData, listItems } from "../../../api";
import { AvField, AvForm } from 'availity-reactstrap-validation';
import Editor from "../../../common/quillEditor";
import { FlowDataEntry } from '../../../common/flowDataEntry'
import DateTimePicker from 'react-datetime-picker';

export class TournamentConfigOptions extends Component {
    constructor(props) {
        super(props)
        const { match: { params } } = this.props;
        this.handleContentChange = this.handleContentChange.bind(this);
        this.handleHookChange = this.handleHookChange.bind(this);

        this.state = {
            loading: true,
            pid: params.pid,
            data: {},
        }
    }

    imageUrlUpdated = (event) => {       
        this.setState( {data: {...this.state.data, imageUrl: event.target.value}});
    }

    onValidSubmit = (event, values) => {
        const formData = new FormData(document.getElementById('mainForm'));
        packData(formData, this.state.data, values)
        formData.append("startDate", this.state.startDate)
        formData.append("endDate", this.state.endDate)        
        formData.append("startRegDate", this.state.startRegDate)
        formData.append("endRegDate", this.state.endRegDate)

        this.onSaveTournamentPage(formData);
    };

    onStartDateChange = startDate => this.setState({ startDate })
    onEndDateChange = endDate => this.setState({ endDate })    
    onStartRegDateChange = startRegDate => this.setState({ startRegDate })
    onEndRegDateChange = endRegDate => this.setState({ endRegDate })
    
    onInvalidSubmit = (event, errors, values) => {
        this.setState({errors, values});
    };

    handleContentChange = (value) => {
        this.setState({
            data: { ...this.state.data, content: value }
        });
    }

    handleHookChange = (value) => {
        this.setState({
            data: { ...this.state.data, hook: value }
        });
    }

    onSaveTournamentPage = (values) => {
        updateObject('tournamentPage', values, this.state.pid).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({pid: d2.tournamentPage._id});
                this.loadTournamentPage();
            }
        });
    };

    loadTournamentPage = () => {
        this.setState({ loading: true});
        if (this.state.pid) {
            getObject('tournamentPage', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ 
                        data: d2.tournamentPage,
                        startDate: new Date(d2.tournamentPage.startDate ? d2.tournamentPage.startDate : null),
                        endDate: new Date(d2.tournamentPage.endDate ? d2.tournamentPage.endDate : null),
                        startRegDate: new Date(d2.tournamentPage.startRegDate ? d2.tournamentPage.startRegDate : null),
                        endRegDate: new Date(d2.tournamentPage.endRegDate ? d2.tournamentPage.endRegDate : null),
                        loading: false
                    });                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();        
    }

    render() {
        const defaultValues = this.state.data;
        
        if (this.state.loading) { return null; }
        else {
            setTimeout(function() {
                document.querySelector(".loader-wrapper").style = "display: none";
            }, 100);       
        return (
            <Fragment>
                <Breadcrumb title="Edit TournamentPage" parents={[{name: "TournamentPage List", url: "/admin/tournamentPage/list"}]}/>
                
                <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={defaultValues}>
                    <FlowDataEntry >
                        <Fragment>                    
                            <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                            <AvField label="Permissions" grid={{xs: 10}} name="permTags" id="permTags" type="text" value={listItems(this.state.data.permTags)}/>
                            <AvField label="Judge Rounds" grid={{xs: 10}} name="judgeRoundMin" id="judgeRoundMin" type="text" />
                            <AvField label="Status" grid={{xs: 10}} name="status" id="status" type="select">                                 
                                <option disabled value="">Select Status</option>                                 
                                <option value="draft" key="draft">Draft</option>     
                                <option value="private" key="private">Private</option>                                                             
                                <option value="publish" key="publish" >Publish</option>                                 
                                <option value="inactive" key="inactive" >Inactive</option>                                                        
                            </AvField>
                        </Fragment>

                        <Fragment> 
                        <div className="row">
                                <div className="col-sm-2">
                                    Registration Start Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onStartRegDateChange}
                                        value={this.state.startRegDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-sm-2">
                                    Registration End Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onEndRegDateChange}
                                        value={this.state.endRegDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                            <br />                                               
                            <div className="row">
                                <div className="col-sm-2">
                                    Start Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onStartDateChange}
                                        value={this.state.startDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-sm-2">
                                    End Date
                                </div>
                                <div className="col-sm-10">  
                                    <DateTimePicker
                                        onChange={this.onEndDateChange}
                                        value={this.state.endDate}
                                        disableClock
                                    />
                                </div>
                            </div>
                        </Fragment>

                        <Editor 
                            content={defaultValues.content}
                            onContentChange={this.handleContentChange}
                        />

                        <Fragment>                    
                            <AvField label="Image Url" grid={{xs: 10}} name="imageUrl" id="imageUrl" type="text" onBlur={(e) => this.imageUrlUpdated(e)}/>
                            <div className="row">
                                <div className="col-sm-2">
                                </div>
                                <div className="col-sm-10">  
                                    <img src={defaultValues.imageUrl}  style={{border:"1px solid #021a40", height:200}} alt="" />
                                </div>
                            </div>
                        </Fragment>

                    </FlowDataEntry >
                </AvForm>   
            </Fragment>
        )
    }
}
}

export default TournamentConfigOptions
